import React, { Component } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import  Layout  from './components/Layout';
import Home from './components/Home';
import Drivers from './components/Drivers';
import Semitrailers from './components/Semitrailers';
import Cars from './components/Cars';
import Transports from './components/Transports';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import AuthorizeComponent from './components/api-authorization/AuthorizeComponent';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ChangePasswordForm } from './components/ChangePasswordForm';



import './css/custom.css'

export default class App extends Component {
    static displayName = App.name;

    render() {

   

    return (
        <Layout/>
    );
  }
}
